import { uiPathLogo } from '@experiences/constants';
import {
    createStyles,
    makeStyles,
} from '@mui/styles';
import clsx from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';

import BottomPageOptions from '../UiBackground/subcomponents/BottomPageOptions';

const useStyles = makeStyles(() =>
    createStyles({
        pageContainer: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%',
        },
        logo: {
            width: '116px',
            minHeight: '40px',
            position: 'absolute',
            left: '12%',
            top: '7%',
        },
    }),
);

interface ISignupChildrenProps {
    center: JSX.Element;
    withLogo: boolean;
}

export const UiVerificationLayout = ({
    center, withLogo,
}: ISignupChildrenProps) => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();

    return (
        <div className={clsx(classes.pageContainer)}>
            {withLogo && (<img
                src={uiPathLogo}
                alt={translate({ id: 'UIPATH_LOGO_ALT' })}
                data-cy="uipath-logo"
                className={classes.logo}
            />)}
            {center}
            <BottomPageOptions languageSelectorOnly={!withLogo} />
        </div>
    );
};
